import {AfterViewInit, Component, NgZone} from "@angular/core";
import {UsersService} from "../../core/customers/glotto-users.service";
import {Router} from "@angular/router";
import {HttpParams} from "@angular/common/http";
import {MessageService} from "primeng/components/common/messageservice";

declare var $;
declare var ScrollMagic;

@Component({
  selector: 'app-ganalottodo-users-component',
  templateUrl: './ganalottodo-users.component.html',
  styleUrls: ['./ganalottodo-users.component.scss']
})
export class GanalottodoUsersComponent implements AfterViewInit {
  page = 0;
  pageSize = 50;
  customers = [];
  private scene: any;
  private pageNumber = 0;
  isEnter = false;
  isLoading = false;
  existsData = true;
  flag = false;
  userToSearch;

  constructor(private usersService: UsersService,
              private router: Router,
              private ngZone: NgZone,
              private messageService: MessageService) {
  }

  selectUser(username: string) {
    this.router.navigate(['ganalottodo', 'usuarios', 'ganalottodo', username]);
  }

  ngAfterViewInit(): void {
    const controller = new ScrollMagic.Controller();
    this.scene = new ScrollMagic.Scene({triggerElement: '#loader', triggerHook: 'onEnter'})
      .addTo(controller)
      .on('enter', (e) => {
        setTimeout(() => {
          this.enter();
        });
      })
      .on('leave', (e) => {
        setTimeout(() => {
          console.log('leave');
        });
      });

  }


  enter() {
    console.log('enter method...');
    this.isEnter = true;
    if (this.existsData) {
      console.log('enter');
      const httpParams = this.getRequestOptions();
      this.debugRequest(httpParams);
      this.usersService.getGanalottodoCustomers(httpParams).subscribe((customers) => {
        console.log(customers);
        Array.prototype.push.apply(this.customers, customers);
        this.pageNumber = this.pageNumber + this.pageSize;
        if (customers.length === 0) {
          this.existsData = false;
        }
      });
      console.log('Dentor de get');
    } else {
      console.log("Ya no hay mas informacion");
    }
  }

  private getRequestOptions() {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('pageSize', this.pageSize.toString());
    httpParams = httpParams.set('offset', this.pageNumber.toString());
    return httpParams;
  }

  private debugRequest(options) {
    console.log('InfiniteScrollComponent#enter:pageNumber');
    console.log(this.pageNumber);
    console.log('InfiniteScrollComponent#enter:pageSize');
    console.log(this.pageSize);
    console.log('InfiniteScrollComponent#enter:options');
    console.log(options);
  }

  leave() {
    this.isEnter = false;
    this.existsData = true;
    console.log('leave');
  }

  searchUser() {
    if (this.userToSearch) {
      console.log('Buscnaod a usuario: ', this.userToSearch);
      let httpParams = new HttpParams();
      httpParams = httpParams.set('username', this.userToSearch);
      this.existsData = false;
      this.usersService.getGanalottodoCustomer(httpParams).subscribe(customer => {
        if (customer) {
          this.customers = [];
          this.customers[0] = customer;
        } else {
          this.messageService.add({
            severity: 'warn',
            summary: '',
            detail: 'No se encontró al usuario: ' + this.userToSearch
          });
        }
        console.log('customer found:', customer);
      });
    } else {
      this.customers = [];
      this.existsData = true;
      this.pageNumber = 0;
      this.enter();
    }


  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/usuarios-ganalottodo/ganalottodo-users.component.ts